import React, { createContext, useContext, useState, useCallback } from 'react';
import { translations } from '../i18n/translations';

const LanguageContext = createContext({});

export const LANGUAGES = [
  { code: 'en', label: 'English' },
  { code: 'fr', label: 'Français' },
  { code: 'it', label: 'Italiano' },
  { code: 'da', label: 'Dansk' },
  { code: 'cs', label: 'Čeština' },
  { code: 'hu', label: 'Magyar' },
  { code: 'pl', label: 'Polski' },
  { code: 'de', label: 'Deutsch' },
  { code: 'fi', label: 'Suomi' },
  { code: 'sv', label: 'Svenska' },
  { code: 'nl', label: 'Nederlands' },
  { code: 'es', label: 'Español' },
  { code: 'sl', label: 'Slovenščina' },
];

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) throw new Error('useLanguage must be used within LanguageProvider');
  return context;
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguageState] = useState(
    () => localStorage.getItem('myfloorid_language') || 'en'
  );

  const setLanguage = useCallback((code) => {
    setLanguageState(code);
    localStorage.setItem('myfloorid_language', code);
  }, []);

  // t(key) — returns translated string or falls back to English
  const t = useCallback((key) => {
    const lang = translations?.[language] || translations?.['en'];
    const fallback = translations?.['en'];
    return lang?.[key] ?? fallback?.[key] ?? key;
  }, [language]);

  const currentLang = LANGUAGES?.find(l => l?.code === language) || LANGUAGES?.[0];

  return (
    <LanguageContext.Provider value={{ language, setLanguage, t, currentLang, LANGUAGES }}>
      {children}
    </LanguageContext.Provider>
  );
};

export default LanguageContext;
